var map = {
	"./App.vue": 3432,
	"./components/GamesList.vue": 7262,
	"./components/GamesList.vue.vue": 7262,
	"./components/MemoryCard.vue": 9994,
	"./components/MemoryGame.vue": 9941,
	"./components/PuzzleGame.vue": 9175,
	"./components/PuzzleItem.vue": 4970,
	"./components/UI/GameBtn.vue": 4141,
	"./components/WinView.vue": 6242,
	"./views/GamesView.vue": 6827,
	"./views/HomeView.vue": 9227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6408;